<mat-tab-group>
    <mat-tab label="Verträge">
        <kiene-dokumente-tab-view></kiene-dokumente-tab-view>
    </mat-tab>
    <mat-tab label="Sonstiges">
        <kiene-dokumente [dokumentType]="[7]" [headline]="'Sonstige Kundendateien'"></kiene-dokumente>
    </mat-tab>
</mat-tab-group>
